// Pure helpers for importing deals (Lone Wolf Back Office).

export const STATE_TEXT = {
  ready: 'Ready', imported: 'Imported', exists: 'Already in Bricks', needs_agent: 'Needs an agent', missing: 'No address',
};

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/** The one primary action for the page, or null. */
export function importAction(data) {
  const c = data?.connection;
  if (!c) return null;
  if (c.status === 'needs_reconnect') return { kind: 'reconnect', label: `Reconnect ${c.short || c.name}` };
  if (!c.fetched_at) return { kind: 'fetch', label: 'Check for deals' };
  const ready = data?.stats?.ready || 0;
  if (ready > 0) return { kind: 'run', label: `Import ${plural(ready, 'deal', 'deals')}` };
  if ((data?.unmatched || []).length > 0) return { kind: 'match', label: 'Match agents' };
  return null;
}

export function importStats(data) {
  const s = data?.stats || {};
  return [
    { label: 'Ready to import', value: String(s.ready || 0) },
    { label: 'Already in Bricks', value: String(s.in_bricks || 0) },
    { label: 'Need attention', value: String(s.attention || 0), attention: (s.attention || 0) > 0 },
  ];
}

export function fmtWhen(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-CA', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/Toronto' });
}

export function fmtDay(iso) {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function connectionMeta(c) {
  if (!c) return [];
  return [
    c.account_name && c.account_name !== c.name ? c.account_name : null,
    c.environment === 'sandbox' ? 'Sandbox' : null,
    c.fetched_at ? `Checked ${fmtWhen(c.fetched_at)}` : 'Not checked yet',
  ].filter(Boolean);
}

const SIDE = { sale: 'Seller side', purchase: 'Buyer side', lease: 'Lease', referral: 'Referral' };

export function rowMeta(r, money) {
  const who = r.agent || (r.source_agent ? `${r.source_agent} isn't matched` : 'No agent');
  const close = r.closing_date ? `${r.status === 'completed' ? 'Closed' : 'Closes'} ${fmtDay(r.closing_date)}` : null;
  return [who, SIDE[r.deal_type] || null, r.sale_price ? money(r.sale_price) : null, close].filter(Boolean);
}

export function resultMessage(result) {
  const { imported = 0, failed = 0 } = result || {};
  if (failed) return { ok: false, text: `${plural(imported, 'deal', 'deals')} imported, ${failed} didn't import` };
  if (!imported) return { ok: true, text: 'Nothing new to import' };
  return { ok: true, text: `${plural(imported, 'deal', 'deals')} imported. Commissions wait for approval.` };
}

export function fetchMessage(found) {
  return found ? `Found ${plural(found, 'deal', 'deals')}` : 'No deals found from the last two years';
}

/** Credentials form is complete when every required field has a value. */
export function missingFields(fields, values) {
  return (fields || []).filter((f) => !f.optional && !String((values || {})[f.key] || '').trim()).map((f) => f.label);
}
